export const VersionUpdateMessage =
  "It looks like you're using an outdated version of the app. Please refresh your browser or clear your cache and reload the page.";
